import { SelectionModel } from "@angular/cdk/collections";
import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { MatInput, MatPaginator, PageEvent } from "@angular/material";
import { LoginService } from "../shared/service/login/login.service";
import { RenovacaoService } from "../shared/service/renovacao/renovacao.service";
import { UtilService } from "../shared/service/util/util.service";
import { debounceTime } from "rxjs/operators";
import { Subject } from "rxjs";
import { Router } from "@angular/router";

@Component({
  selector: "app-renovacao",
  templateUrl: "./renovacao.component.html",
  styleUrls: ["./renovacao.component.css"],
})
export class RenovacaoComponent implements OnInit {
  organizacaoId: number;

  dias = 30;
  diasPossiveis = [5, 10, 20, 30];
  filtro = "";
  private searchSubject = new Subject<string>();
  enviados = false;
  list: any[] = [];
  clientList: any[] = [];
  showProducts = false;
  selectedProduct: any = {};
  selectedClient: any = {};
  selectedCertificates: any[] = [];

  showSpinner: boolean = false;
  displayedColumns: string[] = [
    "select",
    "nomeTitular",
    "cpf",
    "email",
    "validade",
    "acao",
  ];
  pageSize = 10;
  totalItems = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  pageEvent: PageEvent;
  selection = new SelectionModel<Number>(true, []);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private router: Router,
    private utilService: UtilService,
    private loginService: LoginService,
    private renovacaoService: RenovacaoService,
  ) {
    const user = JSON.parse(localStorage.getItem("currentUser"));
    const isVarejo = localStorage.getItem('isVarejo') === 'true';
    const hasRenovation = user.renovation;
    let roles = this.loginService.getRoles();
    const isGestor = roles.indexOf("GESTOR") >= 0;
    const isAdmin = roles.indexOf("ADMINISTRADOR") >= 0;

    if (isVarejo || !hasRenovation || !(isGestor || isAdmin)) {
      this.router.navigate(['/carteira-certificado']);
    }
    this.organizacaoId = user.organizacaoId;
    this.getProducts();
    this.getCertificates();
    this.searchSubject.pipe(debounceTime(300)).subscribe(query => {
      this.getCertificates();
    });
  }

  getCertificates(resetPage: boolean = false) {
    if (resetPage) this.paginator.firstPage();
    this.showSpinner = true;
    let page = this.paginator ? this.paginator.pageIndex : 0;
    let size = this.paginator ? this.paginator.pageSize : this.pageSize;
    this.renovacaoService
      .getCertificates(this.organizacaoId, page, size, this.dias, this.enviados, this.filtro)
      .then((data) => {
        this.showSpinner = false;
        this.list = data.content;
        this.totalItems = data.totalElements;
      })
      .catch((error) => {
        this.showSpinner = false;
        this.getError(error);
      });
  }

  ngOnInit(): void {}

  tabChanged(tab: Number) {
    this.filtro = "";
    this.selection.clear();
    this.enviados = tab == 1;
    this.displayedColumns.splice(5, 1);
    this.displayedColumns.push(tab == 0 ? "acao" : "dataEnvio");
    this.getCertificates(true);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.list.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.list.forEach((row) => this.selection.select(row.id));
  }

  formatDate(value: any, withHour: boolean = false) {
    const date = new Date(value);
    let formated =
      date.getDate().toString().padStart(2, "0") +
      "/" +
      (date.getMonth() + 1).toString().padStart(2, "0") +
      "/" +
      date.getFullYear();
    if (withHour)
      formated =
        formated +
        " - " +
        date.getHours().toString().padStart(2, "0") +
        ":" +
        date.getMinutes().toString().padStart(2, "0");
    return formated;
  }

  applyFilter() {
    this.searchSubject.next(this.filtro);
  }

  getProducts() {
    this.clientList = [];
    this.renovacaoService
      .getProducts()
      .then((data) => {
        data.forEach(c => {
          const productList = [];
          for (const l of c.lotes) {
            for (const p of l.produtos) {
              productList.push({
                name: `${l.grupoId} - ${p.produto} | ${p.descricaoProduto}`,
                loteId: l.loteId,
                grupoId: l.grupoId,
                produto: p.produto,
                key: `${l.loteId}-${l.grupoId}-${p.produto}`
              }); 
            }
          }
          console.log(productList)
          this.clientList.push({
            id: c.clienteId,
            organizacaoId: c.organizacaoId,
            certificadoComunicacaoId: c.certificadoComunicacaoId,
            name: c.cliente,
            productList,
          });
        });
        if(this.clientList.length === 1) this.selectedClient = this.clientList[0];
      })
      .catch((error) => {
        console.log(error);
        this.getError(error);
      });
  }

  sendEmail() {
    if (this.selectedCertificates.length === 0) return;
    this.showProducts = false;
    this.showSpinner = true;
    this.renovacaoService
      .sendEmail(this.selectedCertificates, this.selectedProduct, this.selectedClient)
      .then((data: any) => {
        const errors = data.certificadosRenovados.filter((c) => c.statusRenovacao !== "SUCCESS")
        this.showSpinner = false;
        if (errors.length > 0) {
          errors.map((e) => {
            e.nome = this.list.find((row) => row.id === e.idCertificado).nomeTitular;
            return e;
          });
          this.utilService.showError("Erro ao enviar renovações: " + errors.map((e) => e.nome).join(", "));
        }
        else if (this.selectedCertificates.length === 1) this.utilService.showSuccess("Renovação enviada");
        else this.utilService.showSuccess("Renovações enviadas");
        this.selection.clear();
        this.selectedCertificates = [];
        this.selectedClient = {};
        this.selectedProduct = {};
        this.getCertificates();
      })
      .catch((error) => {
        this.showSpinner = false;
        this.getError(error);
      });
  }

  getError(error) {
    if (error.status === 401 || error.status === 403) {
      this.loginService.logout();
    } else {
      let err;

      if (error.status === 0) {
        err = "Servidor indisponível!";
      } else {
        err = error.message || error;
      }
      this.utilService.showError(err);
    }
  }
}
